import React from "react";
import "./Loader.css";

const Loader: React.FC = () => {
  return <div className="loader"></div>;
};

export default Loader;
